import ScheduledTaskForm from "../Components/ScheduledTasks/ScheduledTaskForm";

const ScheduledTaskFormPage = () => {
  return <ScheduledTaskForm />;
};

export default ScheduledTaskFormPage;
